import { Box, constants, PageSection } from '@redbubble/design-system';
import { FormattedMessage } from '@redbubble/next/intl';
import { NextPage } from 'next/types';
import type { CategorySearchResultsPageProps } from '../../types';

/**
 * L1 category landing page.
 *
 * TODO(DEAP): This is a stub. `getServerSideProps` already returns the category
 * props (config + per-L2 carousel data); the full carousel UI still needs to be
 * built out here.
 */
export const CategoryPage: NextPage<CategorySearchResultsPageProps> = ({
  config,
  carouselData,
}) => (
  <Box element="main">
    <PageSection size={constants.MEDIUM}>
      <h1>
        <FormattedMessage {...config.title} />
      </h1>
      {carouselData.map(({ slug }) => (
        <section key={slug} data-testid={`category-carousel-${slug}`} />
      ))}
    </PageSection>
  </Box>
);
